import advance from 'locales/plus/th/finance/advance.json'
import incomeExpenses from 'locales/plus/th/finance/income-expenses.json'
import overdue from 'locales/plus/th/finance/overdue.json'
import paymentQueue from 'locales/plus/th/finance/payment-queue.json'
import payment from 'locales/plus/th/finance/payment.json'
import salary from 'locales/plus/th/finance/salary.json'
import installment from 'locales/plus/th/finance/installment.json'

export const Payment = {
  ...advance,
  ...incomeExpenses,
  ...overdue,
  ...paymentQueue,
  ...payment,
  ...salary,
  ...installment
}
